import { gql } from 'graphql-tag'

import { orderFieldsCWA } from './orderFieldsCWA'

/**
 * CWA's address-edit mutation. Same as the shared `EDIT_ORDER` but selects
 * {@link orderFieldsCWA} — the superset carries the same null-propagation
 * exposure here as on the tracking query.
 */
export const EDIT_ORDER_CWA = gql`
  mutation editOrderCWA($addressInput: NewAddressInput, $orderId: String) {
    editOrder(addressInput: $addressInput, orderId: $orderId) {
      ...OrderFieldsCWA
    }
  }
  ${orderFieldsCWA}
`
